/**
 * Helper function to get the current hostname of the window
 * @returns {string} - The current hostname of the window - which is ignite or igniteprocurement in production
 */
export const getCurrentDomain = () => {
    return window.location.hostname.split("auth.")[1]?.split(".")?.[0];
}
